import { useState, useRef } from "react";

interface NavigatorWithUsb extends Navigator {
  usb?: any;
}

function encodeLatin1(str: string): Uint8Array {
  const buf = new Uint8Array(str.length);
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    buf[i] = code < 256 ? code : 63;
  }
  return buf;
}

export function useZebraPrinter() {
  const [isPrinting, setIsPrinting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const usbDeviceRef = useRef<any>(null);
  const ifaceNumberRef = useRef<number | null>(null);

  const connect = async () => {
    const nav = navigator as NavigatorWithUsb;
    if (!nav.usb) {
      throw new Error("WebUSB no está soportado en este navegador");
    }

    if (usbDeviceRef.current) {
      return usbDeviceRef.current;
    }

    const device = await nav.usb.requestDevice({
      filters: [{ vendorId: 0x0a5f, classCode: 0x07 }],
    });

    await device.open();
    if (!device.configuration) {
      await device.selectConfiguration(1);
    }

    const ifaceNumber = device.configuration!.interfaces[0].interfaceNumber;
    await device.claimInterface(ifaceNumber);

    usbDeviceRef.current = device;
    ifaceNumberRef.current = ifaceNumber;

    return device;
  };

  const print = async (zpl: string) => {
    setIsPrinting(true);
    setError(null);

    try {
      const device = await connect();
      if (!device.opened) {
        await device.open();
        if (!device.configuration) {
          await device.selectConfiguration(1);
        }
        await device.claimInterface(ifaceNumberRef.current!);
      }

      // const encoder = new TextEncoder();
      await device.transferOut(1, encodeLatin1(zpl));
    } catch (err: any) {
      setError(err.message || String(err));
      throw err;
    } finally {
      setIsPrinting(false);
    }
  };

  return { print, isPrinting, error };
}
